import DeclinedContactsController from '../controllers/DeclinedContactsController';
import CrudActionContainer from './CrudActionContainer';

class DeclinedContactsCRUDActions extends CrudActionContainer {
  constructor() {
    super('DECLINED_CONTACTS');
  }

  async create(
    email: string,
    captchaToken: string,
    zipCode?: string,
    agentCheck?: boolean,
  ) {
    try {
      const response = await DeclinedContactsController.postDeclinedContact(
        email,
        captchaToken,
        zipCode,
        agentCheck,
      );

      return response;
    } catch (error) {
      if (error.status === 422) {
        const response = await error.json();
        return response;
      }
      return {
        success: false,
        errors: ['Something went wrong'],
        error_code: error.status === 429 ? 'too_many_requests' : undefined,
      };
    }
  }

  async confirm(email: string, token: string) {
    try {
      const response = await DeclinedContactsController.confirmDeclinedContact(
        email,
        token,
      );
      return response;
    } catch (error) {
      if (error.status === 422) {
        const response = await error.json();
        return response;
      }
      return {
        success: false,
        errors: ['Something went wrong'],
        error_code: undefined,
      };
    }
  }
}

const declinedContactsCRUDActions = new DeclinedContactsCRUDActions();

export default declinedContactsCRUDActions;
